import { ToggleSwitchControllerContextValue } from "../../state/toggle-switch-controller.context";

export function activateToggleSwitchByName(
    activateToggleSwitch: string | undefined,
    toggleSwitchController: ToggleSwitchControllerContextValue | null,
    sourceName: string,
): void {
    const trimmed = activateToggleSwitch?.trim() ?? "";
    if (!trimmed) {
        return;
    }
    if (!toggleSwitchController) {
        console.error(`${sourceName}: activateToggleSwitch requires a ToggleSwitchController ancestor; toggle side effect skipped.`);
        return;
    }
    if (!toggleSwitchController.isRegistered(trimmed)) {
        console.error(`${sourceName} activateToggleSwitch name not found: ${trimmed}`);
        return;
    }
    toggleSwitchController.open(trimmed);
}
